import { UnauthenticatedPageLayout } from "@/components/layouts/UnauthenticatedPageLayout";

import signInBackgroundMobile from "@/assets/sign-in-background-mobile.jpg";

export const SplashPage = () => {
  return (
    <UnauthenticatedPageLayout>
      {/* <div></div>Loading... */}

      <div className="h-full">
        <img src={signInBackgroundMobile} className="sm:hidden" />
      </div>
    </UnauthenticatedPageLayout>
  )
}
